module.exports = __webpack_public_path__ + "static/media/display-icon-energy.5882444c.png";